import { createReducer } from "@reduxjs/toolkit";
import {
  PROJECT_TEMPLATE_RECURRING_TASK,
  PROJECT_TEMPLATE_TASK,
  PROJECT_TEMPLATE_TASK_LIST,
} from "~/pages/ProjectTemplates/utils";
import {
  FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS,
  DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
  ADD_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
  EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
  BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS,
  MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_LOADING,
  MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_ERROR,
  REORDER_PROJECT_TEMPLATE_ELEMENTS_LOADING,
  REORDER_PROJECT_TEMPLATE_LISTS_SUCCESS,
  FETCH_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
  UNASSIGN_CLIENT_FROM_PROJECT_TEMPLATE_SUBTASKS,
} from "~/store/action_types";

const projectTemplateElements = createReducer({}, (builder) => {
  builder
    .addMatcher(
      (action) =>
        [
          FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS,
          FETCH_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
          ADD_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
          EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS,
          BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        if (!action.response || !action.response.entities || !action.response.entities.projectTemplateElements) {
          return;
        }
        return { ...state, ...action.response.entities.projectTemplateElements };
      }
    )
    .addMatcher(
      (action) => [DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS].includes(action.type),
      (state, action) => {
        const { id, elementType } = action;
        if (elementType === PROJECT_TEMPLATE_TASK_LIST) {
          Object.keys(state).forEach((key) => {
            if (
              state[key].task_list_id === id &&
              [PROJECT_TEMPLATE_TASK, PROJECT_TEMPLATE_RECURRING_TASK].includes(state[key].class)
            ) {
              delete state[key];
            }
          });
        }
        if (state[id]) {
          delete state[id];
        }
      }
    )
    .addMatcher(
      (action) => [REORDER_PROJECT_TEMPLATE_ELEMENTS_LOADING].includes(action.type),
      (state, action) => {
        const { order } = action;
        order.map((id, index) => {
          if (state[id]) {
            state[id] = {
              ...state[id],
              position: index + 1,
            };
          }
        });
      }
    )
    .addMatcher(
      (action) => [MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_LOADING].includes(action.type),
      (state, action) => {
        const { id, targetTaskListId } = action;

        state[id] = {
          ...state[id],
          task_list_id: targetTaskListId,
        };
      }
    )
    .addMatcher(
      (action) => [MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_ERROR].includes(action.type),
      (state, action) => {
        const { id, prevPosition, sourceTaskListId } = action;

        if (state[id]) {
          state[id] = {
            ...state[id],
            task_list_id: sourceTaskListId,
            position: prevPosition,
          };
        }
      }
    )
    .addMatcher(
      (action) => [REORDER_PROJECT_TEMPLATE_LISTS_SUCCESS].includes(action.type),
      (state, action) => {
        const { response = [] } = action;
        if (response.length) {
          response.map((id, index) => {
            if (state[id]) {
              state[id] = {
                ...state[id],
                position: index + 1,
              };
            }
          });
        }
      }
    )
    .addMatcher(
      (action) => [UNASSIGN_CLIENT_FROM_PROJECT_TEMPLATE_SUBTASKS].includes(action.type),
      (state, action) => {
        const { subtaskIds = [] } = action;
        subtaskIds.forEach((subtaskId) => {
          if (state[subtaskId]) {
            state[subtaskId] = {
              ...state[subtaskId],
              assignee_id: 0,
            };
          }
        });
      }
    );
});

export default projectTemplateElements;
